<form (submit)="handleSubmit()" [formGroup]="form" class="pt-3">
  <swiper-container init="false" #sliderRef>
    <swiper-slide
      class="flex flex-col items-center px-4 sm:px-8"
      [attr.inert]="!isWelcomeSlideActive() ? '' : null"
    >
      <img
        class="mt-3 mb-6 max-w-xs"
        src="assets/images/onboarding/mascots.png"
        alt=""
      />
      <div class="flex flex-col items-center">
        <h2
          class="mb-7 text-center text-xl font-semibold text-neutral-low-dark"
        >
          {{ 'onboarding.title' | translate }}
        </h2>
        <p class="mb-0 text-center text-balance">
          {{ 'onboarding.title' | translate }}
          {{ 'onboarding.registration.salutation' | translate }}
          <em class="font-semibold text-brand-primary-pure not-italic">{{
            username
          }}</em
          >{{ 'onboarding.registration.title' | translate }}
        </p>
        <p class="mb-0 text-center">
          {{ 'onboarding.registration.subtitle' | translate }}
        </p>
      </div>
    </swiper-slide>
    <swiper-slide
      class="px-4 sm:px-8"
      [attr.inert]="!isProfileSlideActive() ? '' : null"
    >
      <h2 class="mb-8 text-center text-xl font-semibold text-neutral-low-dark">
        {{ 'onboarding.profile_selection.title' | translate }}
      </h2>
      <p class="mb-6 text-lg font-medium text-brand-primary-pure">
        {{ 'onboarding.profile_selection.subtitle' | translate }}
      </p>

      <div class="-m-1 flex flex-col gap-4" formArrayName="profiles">
        @for (control of profiles.controls; track $index) {
          <div class="flex items-center p-1" [formGroupName]="$index">
            <liv-checkbox
              [key]="control.get('value')?.value?.toString() ?? ''"
              formControlName="checked"
            />
            <label
              [attr.for]="control.get('value')?.value?.toString() ?? ''"
              class="font-normal text-neutral-low-dark"
              >{{ communityProfiles()[$index].nome }}</label
            >
          </div>
        }
      </div>
    </swiper-slide>
    <swiper-slide
      class="px-4 sm:px-8"
      [attr.inert]="!isGradesSlideActive() ? '' : null"
    >
      <h2 class="mb-8 text-center text-xl font-semibold text-neutral-low-dark">
        {{ 'onboarding.grades_selection.title' | translate }}
      </h2>
      <div class="-m-1 flex flex-col gap-4" formArrayName="grades">
        @for (control of grades.controls; track $index) {
          <div
            class="grid auto-rows-auto grid-cols-3 gap-x-0 gap-y-1 sm:grid-cols-5"
            [formGroupName]="$index"
          >
            <span
              class="col-span-full p-1 text-sm font-medium text-brand-primary-pure"
            >
              {{ segments()[$index].nome }}
            </span>
            @for (grade of segments()[$index].anos; track grade.id) {
              <div
                class="flex items-center p-1"
                [formGroupName]="grade.id.toString()"
              >
                <liv-checkbox [key]="grade.nome" formControlName="checked" />
                <label
                  [attr.for]="grade.nome"
                  class="font-normal text-neutral-low-dark"
                  >{{ grade.nome }}</label
                >
              </div>
            }
          </div>
        }
      </div>
    </swiper-slide>
    <swiper-slide
      class="flex flex-col items-center px-4 sm:px-8"
      [attr.inert]="!isContactSlideActive() ? '' : null"
    >
      <img class="mb-8 max-w-31.25" src="assets/icons/phone.svg" alt="" />
      <div class="m-auto">
        <h2
          class="mb-7 text-center text-xl font-semibold text-neutral-low-dark"
        >
          {{ 'onboarding.contact.title' | translate }}
        </h2>
        <p class="mb-0 max-w-md text-center">
          {{ 'onboarding.contact.subtitle' | translate }}
        </p>
      </div>
      <liv-document-input
        class="slide_phone w-full"
        type="phone"
        formControlName="phone"
        placeholder="(85) 99966 - 6699"
      />
    </swiper-slide>
    <swiper-slide
      class="flex flex-col items-center px-4 sm:px-8"
      [attr.inert]="!isWhatsappSlideActive() ? '' : null"
    >
      <img class="mb-8 max-w-31.25" src="assets/icons/whatsapp.svg" alt="" />
      <div>
        <h2
          class="mb-7 text-center text-xl font-semibold text-neutral-low-dark"
        >
          {{ 'onboarding.whatsapp_invite.title' | translate }}
        </h2>
        <div class="max-w-md">
          <p class="text-center">
            {{ 'onboarding.whatsapp_invite.subtitle' | translate }}
          </p>
          <p class="text-center">
            {{ 'onboarding.whatsapp_invite.description' | translate }}
          </p>
          <p class="mb-0 text-center">
            {{ 'onboarding.whatsapp_invite.call_to_action' | translate }}
            <a
              class="font-bold text-brand-primary-pure underline"
              [href]="whatsappChannel() | safeTransform: 'RESOURCE'"
              target="_blank"
              >{{ 'onboarding.whatsapp_invite.button' | translate }}</a
            >
          </p>
        </div>
      </div>
    </swiper-slide>
  </swiper-container>

  <div class="flex flex-col gap-3 px-4 pt-8 sm:flex-row-reverse sm:px-8">
    @if (isFirstSlide()) {
      <button
        livButton
        type="button"
        variant="filled"
        intent="primary"
        shape="pill"
        size="lg"
        fluid
        (click)="slideToNext()"
      >
        {{ 'buttons.start' | translate }}
      </button>

      <button
        livButton
        type="button"
        variant="outline"
        intent="primary"
        shape="pill"
        size="lg"
        [autofocus]="true"
        fluid
        [loading]="isSavingSeeLater"
        (click)="handleSeeLater()"
      >
        {{ 'buttons.see_later' | translate }}
      </button>
    } @else {
      @if (isLastSlide()) {
        <button
          livButton
          type="submit"
          variant="filled"
          intent="primary"
          shape="pill"
          size="lg"
          fluid
          [loading]="updateUserRegistration()"
        >
          {{ 'buttons.conclude' | translate }}
        </button>
      } @else {
        <button
          livButton
          type="button"
          variant="filled"
          intent="primary"
          shape="pill"
          size="lg"
          fluid
          [disabled]="!handleNextStep()"
          (click)="slideToNext()"
        >
          {{ 'buttons.next' | translate }}
        </button>
      }

      <button
        livButton
        type="button"
        variant="outline"
        intent="primary"
        shape="pill"
        size="lg"
        fluid
        (click)="slideToPrevious()"
      >
        {{ 'buttons.back' | translate }}
      </button>
    }
  </div>
</form>
